// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointJsonVersion {
	V1 = 1,
	V2 = 2,
}

export const ClientEndpointJsonVersionDisplayNames: { [key in keyof typeof ClientEndpointJsonVersion]?: string} = {
	"V1": "V1",
	1 : "V1",
	"V2": "V2",
	2 : "V2",
}

export const getClientEndpointJsonVersionDisplayName = (key: ClientEndpointJsonVersion | (keyof typeof ClientEndpointJsonVersion & string)) => {
	return ClientEndpointJsonVersionDisplayNames[key];
}

